import { TSelectItem } from '../components/types';
import {
    ADMIN_LEVEL_ACCESS,
    DEVELOPER_LEVEL_ACCESS,
    GROUP_LEVEL_ACCESS,
    TAccessLevel,
} from 'src/components/access';
import { TFunction } from 'src/constants/i18next';
import {
    BOTH_DIGITAL_CARTYPE,
    DIGITAL_AREA,
    NEW_CARTYPE,
    PREOWNED_CARTYPE,
} from 'src/constants/user';
import { IUser } from 'src/interfaces/user';

/**
 * Maps the areas to a select item
 *
 * @param {TAccessLevel} accessLevel
 * @param {Partial<IUser>} user
 * @param {TFunction} t
 * @return {*}  {TSelectItem[]}
 */
export const mapAreas = (
    accessLevel: TAccessLevel,
    user: Partial<IUser>,
    t: TFunction
): TSelectItem[] => {
    if (
        accessLevel === DEVELOPER_LEVEL_ACCESS ||
        accessLevel === GROUP_LEVEL_ACCESS
    ) {
        return [
            {
                label: t('Areas.nuevos'),
                value: 'nuevos',
            },
            {
                label: t('Areas.seminuevos'),
                value: 'seminuevos',
            },
            {
                label: t('Areas.bdc'),
                value: 'bdc',
            },
            {
                label: t('Areas.service'),
                value: 'service',
            }
        ];
    }

    if (accessLevel === ADMIN_LEVEL_ACCESS) {
        let responseAreas = [];

        if (
            user.carType === NEW_CARTYPE ||
            user.carType === BOTH_DIGITAL_CARTYPE
        ) {
            responseAreas.push({
                label: t('Areas.nuevos'),
                value: 'nuevos',
            });
        }

        if (
            user.carType === PREOWNED_CARTYPE ||
            user.carType === BOTH_DIGITAL_CARTYPE
        ) {
            responseAreas.push({
                label: t('Areas.seminuevos'),
                value: 'seminuevos',
            });

            user?.areas?.forEach((area) => {
                if (area !== DIGITAL_AREA) {
                    responseAreas.push({
                        label: t(`Areas.${area}`),
                        value: area,
                    });
                }
            });

            return responseAreas;
        }
    }
    return [];
};
